export default __webpack_public_path__ + "static/media/footer-card-image-desktop.ea372280.svg";